import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import {
  extendArray,
  PageSettingsModel,
  SelectionSettingsModel,
  SortSettingsModel,
  TreeGridComponent,
} from "@syncfusion/ej2-angular-treegrid";
import {
  NzContextMenuService,
  NzDropdownMenuComponent,
} from "ng-zorro-antd/dropdown";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { NzFormatEmitEvent, NzTreeNode } from "ng-zorro-antd/tree";
import { CookieService } from "ngx-cookie-service";
import { featureMaster } from "src/app/Models/BasicForms/featureMaster";
import { moduleMaster } from "src/app/Models/BasicForms/moduleMaster";
import { taskSubtaskMaster } from "src/app/Models/BasicForms/taskSubtaskMaster";
import { worklogM } from "src/app/Models/BasicForms/worklogM";
import { ApiService } from "src/app/Service/api.service";
// import { CommentComponent } from "../Comment/comment/comment.component";
import { FeatureViewComponent } from "../ModuleFeatureView/feature-view/feature-view.component";
import { ModuleFeatureViewComponent } from "../ModuleFeatureView/module-feature-view/module-feature-view.component";

@Component({
  selector: "app-roadmap",
  templateUrl: "./roadmap.component.html",
  styleUrls: ["./roadmap.component.css"],
})
export class RoadmapComponent implements OnInit {
  searchText = "";
  formTitle = "Roadmap";
  activatedNode?: NzTreeNode;
  public toolbarOption: string[];

  nodes = [];
  public sortSettings: SortSettingsModel;
  public pageSettings: PageSettingsModel;
  public selectionOptions: SelectionSettingsModel;

  @ViewChild("treegridObj")
  public treegridObj: TreeGridComponent;
  selIndex: any;

  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService
  ) {}

  ngOnInit() {
    this.loadAllProjects();
    this.getDefaultProject();
    this.toolbarOption = ["Search"];

    this.sortSettings = {
      columns: [{ field: "title", direction: "Ascending" }],
    };
    this.pageSettings = { pageSize: 10 };
    this.selectionOptions = { type: "Multiple" };
  }

  PROJECT_ID: any;
  STATUS = "All";
  FOR_ME: boolean = true;

  getDefaultProject() {
    var defaultProject = sessionStorage.getItem("projectID");

    if (
      defaultProject != "" &&
      defaultProject != undefined &&
      defaultProject != null
    ) {
      if (this.cookie.get("level") >= "4") {
        this._apiService
          .getAllMappedProjects(
            0,
            0,
            "ID",
            "desc",
            " and IS_ACTIVE=1 and USER_ID=" +
              this._apiService.userId +
              " and PROJECT_ID=" +
              defaultProject
          )
          .subscribe(
            (projectData) => {
              if (projectData["code"] == 200) {
                if (projectData["count"] == 0) {
                  this.PROJECT_ID = 0;
                } else {
                  this.PROJECT_ID = Number(defaultProject);
                }

                this.getRoadmapDetails();
              }
            },
            (err) => {}
          );
      } else {
        this.PROJECT_ID = Number(defaultProject);

        this.getRoadmapDetails();
      }
    }
  }

  projectList = [];

  loadAllProjects() {
    this.projectList = [];

    if (
      this.cookie.get("level") == "1" ||
      this.cookie.get("level") == "2" ||
      this.cookie.get("level") == "3"
    ) {
      this._apiService
        .getAllProjects(0, 0, "START_DATE", "desc", " and IS_ACTIVE=1")
        .subscribe(
          (projectData) => {
            if (projectData["code"] == 200) {
              this.projectList = projectData["data"];
            }
          },
          (err) => {}
        );
    } else {
      this._apiService
        .getAllMappedProjects(
          0,
          0,
          "START_DATE",
          "desc",
          " and IS_ACTIVE=1 and USER_ID=" + this._apiService.userId
        )
        .subscribe(
          (projectData) => {
            if (projectData["code"] == 200) {
              this.projectList = projectData["data"];
            }
          },
          (err) => {}
        );
    }
  }

  isRoadmapLoading = false;

  getRoadmapDetails() {
    sessionStorage.setItem("projectID", this.PROJECT_ID.toString());

    this.nodes = [];
    this.isRoadmapLoading = true;

    if (this.STATUS == "All") {
      if (this.FOR_ME) {
        this._apiService
          .getMappingWiseKanbanView(2, this.PROJECT_ID, this._apiService.userId)
          .subscribe(
            (data2: any) => {
              if (data2["code"] == 200) {
                this.isRoadmapLoading = false;

                if (data2 != undefined && data2["data"] != null) {
                  this.nodes = JSON.parse(data2["data"]);
                }
              }
            },
            (err) => {}
          );
      } else {
        this._apiService.getKanbanView(1, this.PROJECT_ID).subscribe(
          (data2: any) => {
            if (data2["code"] == 200) {
              this.isRoadmapLoading = false;

              if (data2 != undefined && data2["data"] != null) {
                this.nodes = JSON.parse(data2["data"]);
              }
            }
          },
          (err) => {}
        );
      }
    } else {
      if (this.FOR_ME) {
        this._apiService
          .getMappingWiseStatusWiseKanbanView(
            2,
            this.PROJECT_ID,
            this._apiService.userId,
            this.STATUS
          )
          .subscribe(
            (data2: any) => {
              if (data2["code"] == 200) {
                this.isRoadmapLoading = false;

                if (data2 != undefined && data2["data"] != null) {
                  this.nodes = JSON.parse(data2["data"]);
                }
              }
            },
            (err) => {}
          );
      } else {
        this._apiService
          .getKanbanByStatusView(1, this.PROJECT_ID, this.STATUS)
          .subscribe(
            (data2: any) => {
              if (data2["code"] == 200) {
                this.isRoadmapLoading = false;

                if (data2 != undefined && data2["data"] != null) {
                  this.nodes = JSON.parse(data2["data"]);
                }
              }
            },
            (err) => {}
          );
      }
    }
  }

  // @ViewChild(CommentComponent) CommentComponentVar: CommentComponent;
  typeForComment: number;
  typeIDForComment: number;
  commentDrawerTitle = "";
  taskSubtaskDrawerData: taskSubtaskMaster = new taskSubtaskMaster();
  commentDrawerVisible = false;

  spinnn:boolean=false
  // @ViewChild(FeatureViewComponent)
  // FeatureViewComponentVar: FeatureViewComponent;
  viewFeatureDrawerTitle = "";
  featureDrawerData: featureMaster = new featureMaster();
  viewFeatureDrawerVisible = false;

  // @ViewChild(ModuleFeatureViewComponent)
  // ModuleFeatureViewComponentVar: ModuleFeatureViewComponent;
  
  // @ViewChild(ModuleFeatureViewComponent) 
  // ModuleFeatureViewComponentVar!: ModuleFeatureViewComponent; 
  // Use non-null assertion
  // @ViewChild(ModuleFeatureViewComponent, { static: false }) ModuleFeatureViewComponentVar: ModuleFeatureViewComponent;

  viewModuleDrawerTitle = "";
  moduleDrawerData: moduleMaster = new moduleMaster();
  viewModuleDrawerVisible = false;

  commentDrawerVisible11 = false;
  viewModuleDrawerVisible11 = false;
  viewFeatureDrawerVisible11 = false;
  worklogDrawerVisible11 = false;

  type: number;
  typeID: number;
  isSpinning11:boolean=false
  

  goToTask(id, type) {
    this.isRoadmapLoading = true;
    this.isSpinning11 = true;


    if (type == 4) {
      this._apiService
        .getAllTaskSubtask(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;
            this.commentDrawerVisible11 = true;


            this.taskSubtaskDrawerData = datas["data"][0];

            var data = this.taskSubtaskDrawerData;

            this.commentDrawerTitle = "Task/ Subtask Details";
            this.taskSubtaskDrawerData = Object.assign({}, data);
            this.commentDrawerVisible = true;
            this.type = 4;

            this.typeForComment = this.type;
            this.typeIDForComment = data.ID;

            // this.CommentComponentVar.loadAllSubtasks(data.ID);

            // this.CommentComponentVar.showTags(data.TAGS);
            // this.CommentComponentVar.getAttachmentIDWise(this.type, data.ID);
            // this.CommentComponentVar.getCommentIDWise(this.type, data.ID);
            // this.CommentComponentVar.getWorklogIDWise(this.type, data.ID);

            // if (data["TASK_ASSIGNEE_IDS"] == null) {
            //   data["TASK_ASSIGNEE_IDS"] = "0";
            //   data["TASK_ASSIGNEE_NAMES"] = "";
            // }

            // if (data["TASK_REPORTER_IDS"] == null) {
            //   data["TASK_REPORTER_IDS"] = "0";
            //   data["TASK_REPORTER_NAMES"] = "";
            // }

            // this.CommentComponentVar.getAssigneeFromID(
            //   data["TASK_ASSIGNEE_NAMES"]
            // );
            // this.CommentComponentVar.getReporterFromID(
            //   data["TASK_REPORTER_IDS"]
            // );

         
            // this.CommentComponentVar.assignInputHidden = true;
            // this.CommentComponentVar.loadAllAssignee(data['TASK_ASSIGNEE_IDS']);
            // this.CommentComponentVar.loadAssigneeMappingWise(data['PROJECT_ID'], data['TASK_ASSIGNEE_IDS']);
            // this.CommentComponentVar.loadAllRoles();
            // this.CommentComponentVar.getAssigneesInInput(data['TASK_ASSIGNEE_IDS'].split(','));
          },
          (err) => {
            if (err["ok"] == false)
              this.notificationService.error("Server Not Found", "");
          }
        );
    } else if (type == 5) {
      this._apiService
        .getAllTaskSubtask(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;

            this.taskSubtaskDrawerData = datas["data"][0];

            var data = this.taskSubtaskDrawerData;

            this.commentDrawerTitle = "Task/ Subtask Details";
            this.taskSubtaskDrawerData = Object.assign({}, data);
            this.commentDrawerVisible = true;
            this.type = 5;

            this.typeForComment = this.type;
            this.typeIDForComment = data.ID;

            // this.CommentComponentVar.loadAllParentTasks(data.PARENT_ID);

            // this.CommentComponentVar.showTags(data.TAGS);
            // this.CommentComponentVar.getAttachmentIDWise(this.type, data.ID);
            // this.CommentComponentVar.getCommentIDWise(this.type, data.ID);
            // this.CommentComponentVar.getWorklogIDWise(this.type, data.ID);

            // if (data["SUBTASK_ASSIGNEE_IDS"] == null) {
            //   data["SUBTASK_ASSIGNEE_IDS"] = "0";
            // }

            // if (data["SUBTASK_REPORTER_IDS"] == null) {
            //   data["SUBTASK_REPORTER_IDS"] = "0";
            // }

            // this.CommentComponentVar.getAssigneeFromID(
            //   data["SUBTASK_ASSIGNEE_NAMES"]
            // );
            // this.CommentComponentVar.getReporterFromID(
            //   data["SUBTASK_REPORTER_IDS"]
            // );

            // Getting Assign
            // this.CommentComponentVar.assignInputHidden = true;
            // this.CommentComponentVar.loadAllAssignee(data['TASK_ASSIGNEE_IDS']);
            // this.CommentComponentVar.loadAssigneeMappingWise(data['PROJECT_ID'], data['SUBTASK_ASSIGNEE_IDS']);
            // this.CommentComponentVar.loadAllRoles();
            // this.CommentComponentVar.getAssigneesInInput(data['TASK_ASSIGNEE_IDS'].split(','));
          },
          (err) => {
            if (err["ok"] == false)
              this.notificationService.error("Server Not Found", "");
          }
        );
    } else if (type == 2) {
      this._apiService
        .getAllModules(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;
            this.viewModuleDrawerVisible11 = true;

            // @ViewChild(ModuleFeatureViewComponent);
            this.moduleDrawerData = datas["data"][0];

            var data = this.moduleDrawerData;

            this.viewModuleDrawerTitle = "Module Details";
            this.moduleDrawerData = Object.assign({}, data);
            this.viewModuleDrawerVisible = true;

            this.type = 2;
            this.typeID = data.ID;
          

            // this.ModuleFeatureViewComponentVar.getFeatureModuleIDWise(data.ID);

            // this.ModuleFeatureViewComponentVar.getAttachmentIDWise(
            //   this.type,
            //   data.ID
            // );
            // this.ModuleFeatureViewComponentVar.getCommentIDWise(
            //   this.type,
            //   data.ID
            // );
            // this.ModuleFeatureViewComponentVar.getWorklogIDWise(
            //   this.type,
            //   data.ID
            // );

            // if (data["ASSIGNEE_IDS"] == null) {
            //   data["ASSIGNEE_IDS"] = "0";
            // }

            // if (data["REPORTER_IDS"] == null) {
            //   data["REPORTER_IDS"] = "0";
            // }

            // this.ModuleFeatureViewComponentVar.getAssigneeFromID(
            //   data["ASSIGNEE_IDS"]
            // );
            // this.ModuleFeatureViewComponentVar.getReporterFromID(
            //   data["REPORTER_IDS"]
            // );

            // this.ModuleFeatureViewComponentVar.assignInputHidden = true;

            // this.ModuleFeatureViewComponentVar.loadAllAssignee(data['ASSIGNEE_IDS']);
            // this.ModuleFeatureViewComponentVar.loadAssigneeMappingWise(data['PROJECT_ID'], data['ASSIGNEE_IDS']);
            // this.ModuleFeatureViewComponentVar.loadAllRoles();
            // this.ModuleFeatureViewComponentVar.getAssigneesInInput(data['ASSIGNEE_IDS'].split(','));
          },
          (err) => {
            if (err["ok"] == false)
              this.notificationService.error("Server Not Found", "");
          }
        );
    } else if (type == 3) {
      this._apiService
        .getAllFeatures(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;

            this.featureDrawerData = datas["data"][0];

            var data = this.featureDrawerData;

            this.viewFeatureDrawerTitle = "Feature Details";
            this.featureDrawerData = Object.assign({}, data);
            this.viewFeatureDrawerVisible = true;

            this.type = 3;
            this.typeID = data.ID;

            // this.FeatureViewComponentVar.getAttachmentIDWise(
            //   this.type,
            //   data.ID
            // );
            // this.FeatureViewComponentVar.getCommentIDWise(this.type, data.ID);
            // this.FeatureViewComponentVar.getWorklogIDWise(this.type, data.ID);
            // this.FeatureViewComponentVar.loadAllModules(data["PROJECT_ID"]);

            // if (data["ASSIGNEE_IDS"] == null) {
            //   data["ASSIGNEE_IDS"] = "0";
            // }

            // if (data["REPORTER_IDS"] == null) {
            //   data["REPORTER_IDS"] = "0";
            // }

            // this.FeatureViewComponentVar.getAssigneeFromID(
            //   data["ASSIGNEE_IDS"]
            // );
            // this.FeatureViewComponentVar.getReporterFromID(
            //   data["REPORTER_IDS"]
            // );

            // this.FeatureViewComponentVar.assignInputHidden = true;

            // this.FeatureViewComponentVar.loadAllAssignee(data['ASSIGNEE_IDS']);
            // this.FeatureViewComponentVar.loadAssigneeMappingWise(data['PROJECT_ID'], data['ASSIGNEE_IDS']);
            // this.FeatureViewComponentVar.loadAllRoles();
            // this.FeatureViewComponentVar.getAssigneesInInput(data['ASSIGNEE_IDS'].split(','));
          },
          (err) => {
            if (err["ok"] == false)
              this.notificationService.error("Server Not Found", "");
          }
        );
    }
  }

  commentDrawerClose() {
    this.commentDrawerVisible = false;
    this.getRoadmapDetails();
  }

  viewModuleDetailsDrawerClose() {
    this.viewModuleDrawerVisible = false;
    this.getRoadmapDetails();
  }

  viewFeatureDetailsDrawerClose() {
    this.viewFeatureDrawerVisible = false;
    this.getRoadmapDetails();
  }

  worklogDrawerVisible = false;
  worklogDrawerTitle = "";
  worklogDrawerData: worklogM = new worklogM();
  typeForWorklogDrawer: number;
  typeIDForWorklogDrawer: number;

  estimatedHH: any;
  estimatedMM: any;
  estimatedSS: any;
  estimatedMandays: any;
  timeOrMandays: string;

  roadmaptrue:boolean=true

  addWorklog(id, type) {
    this.isRoadmapLoading = true;

    if (type == 2) {
      this._apiService
        .getAllModules(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;
            this.moduleDrawerData = datas["data"][0];

            var data = this.moduleDrawerData;

            this.worklogDrawerTitle = "Add Worklog > " + data.NAME;
            this.worklogDrawerData = new worklogM();
            this.worklogDrawerVisible = true;
            this.worklogDrawerData.IS_ACTIVE = true;

            this.worklogDrawerData.SPENT_HOURS = 0;
            this.worklogDrawerData.SPENT_MINUTES = 0;
            this.worklogDrawerData.SPENT_SECONDS = 0;

            this.worklogDrawerData.TYPE = type;
            this.worklogDrawerData.TYPE_ID = data.ID;

            this.typeForWorklogDrawer = type;
            this.typeIDForWorklogDrawer = data.ID;

            this.estimatedMandays = data.ESTIMATED_MANDAYS;
            this.timeOrMandays = "M";
          },
          (err) => {}
        );
    } else if (type == 3) {
      this._apiService
        .getAllFeatures(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;
            this.featureDrawerData = datas["data"][0];

            var data = this.featureDrawerData;

            this.worklogDrawerTitle = "Add Worklog > " + data.NAME;
            this.worklogDrawerData = new worklogM();
            this.worklogDrawerVisible = true;
            this.worklogDrawerData.IS_ACTIVE = true;

            this.worklogDrawerData.SPENT_HOURS = 0;
            this.worklogDrawerData.SPENT_MINUTES = 0;
            this.worklogDrawerData.SPENT_SECONDS = 0;

            this.worklogDrawerData.TYPE = type;
            this.worklogDrawerData.TYPE_ID = data.ID;

            this.typeForWorklogDrawer = type;
            this.typeIDForWorklogDrawer = data.ID;

            this.estimatedMandays = data.ESTIMATED_MANDAYS;
            this.timeOrMandays = "M";
          },
          (err) => {}
        );
    } else if (type == 4 || type == 5) {
      this._apiService
        .getAllTaskSubtask(0, 0, "ID", "desc", " and ID=" + id)
        .subscribe(
          (datas) => {
            this.isRoadmapLoading = false;
            this.taskSubtaskDrawerData = datas["data"][0];

            var data = this.taskSubtaskDrawerData;

            this.worklogDrawerTitle = "Add Worklog > " + data.NAME;
            this.worklogDrawerData = new worklogM();
            this.worklogDrawerVisible = true;
            this.worklogDrawerData.IS_ACTIVE = true;

            this.worklogDrawerData.SPENT_HOURS = 0;
            this.worklogDrawerData.SPENT_MINUTES = 0;
            this.worklogDrawerData.SPENT_SECONDS = 0;

            this.worklogDrawerData.TYPE = type;
            this.worklogDrawerData.TYPE_ID = data.ID;

            this.typeForWorklogDrawer = type;
            this.typeIDForWorklogDrawer = data.ID;

            this.estimatedHH = data.ESTIMATED_HOURS;
            this.estimatedMM = data.ESTIMATED_MINUTES;
            this.estimatedSS = data.ESTIMATED_SECONDS;
            this.timeOrMandays = "T";
          },
          (err) => {}
        );
    }
  }

  worklogDrawerClose() {
    this.worklogDrawerVisible = false;
  }

  get callBackWorklogDrawerClose() {
    return this.worklogDrawerClose.bind(this);
  }

  tooltipForView(nodesTitle) {
    return "View " + nodesTitle;
  }

  tooltipForWorklog(nodesTitle) {
    return "Add Worklog for " + nodesTitle;
  }

  // changes by shubham
  // getFeatureModuleIDWise(moduleID) {
  //   this.isFeatureSpinning = true;

  //   let filterStr = " and IS_ACTIVE=1 and MODULE_ID=" + moduleID;
  //   this._apiService.getAllFeatures(0, 0, "ID", "desc", filterStr).subscribe(
  //     (data) => {
  //       this.isFeatureSpinning = false;

  //       this.featureData = data["data"];
  //     },
  //     (err) => {
  //       if (err["ok"] == false)
  //         this.notificationService.error("Server Not Found", "");
  //     }
  //   );
  // }

  // getAttachmentIDWise(type, typeID) {
  //   this.isAttachmentSpinning = true;

  //   let filterStr =
  //     " and IS_ACTIVE=1 and TYPE=" + type + " and TYPE_ID=" + typeID;
  //   this._apiService.getAllAttachments(0, 0, "ID", "desc", filterStr).subscribe(
  //     (data) => {
  //       this.isAttachmentSpinning = false;

  //       this.attachmentData = data["data"];
  //     },
  //     (err) => {
  //       if (err["ok"] == false)
  //         this.notificationService.error("Server Not Found", "");
  //     }
  //   );
  // }

  // getCommentIDWise(type, typeID, pageIndex: number = 1, pageSize: number = 5) {
  //   this.isLoadMoreButtonHide = false;

  //   if (pageSize == 5) {
  //     this.isCommentSpinning = true;
  //     this.addMorePage = 5;
  //   } else {
  //     this.isLoadMoreButtonSpinning = true;
  //   }

  //   let filterStr =
  //     " and IS_ACTIVE=1 and TYPE=" + type + " and TYPE_ID=" + typeID;
  //   this._apiService
  //     .getComments(pageIndex, pageSize, "COMMENT_DATETIME", "desc", filterStr)
  //     .subscribe(
  //       (data) => {
  //         this.isCommentSpinning = false;
  //         this.isLoadMoreButtonSpinning = false;
  //         this.commentData = data["data"];

  //         if (data["data"].length == data["count"]) {
  //           this.isLoadMoreButtonHide = true;
  //         }
  //       },
  //       (err) => {
  //         if (err["ok"] == false)
  //           this.notificationService.error("Server Not Found", "");
  //       }
  //     );
  // }

  // getWorklogIDWise(type, typeID, pageIndex: number = 1, pageSize: number = 5) {
  //   this.isWorklogLoadMoreButtonHide = false;

  //   if (pageSize == 5) {
  //     this.isWorklogSpinning = true;
  //     this.worklogAddMorePage = 5;
  //   } else {
  //     this.isWorklogLoadMoreButtonSpinning = true;
  //   }

  //   let filterStr =
  //     " and IS_ACTIVE=1 and TYPE=" + type + " and TYPE_ID=" + typeID;
  //   this._apiService
  //     .getAllWorklogs(pageIndex, pageSize, "WORKED_DATETIME", "desc", filterStr)
  //     .subscribe(
  //       (data) => {
  //         this.isWorklogSpinning = false;
  //         this.isWorklogLoadMoreButtonSpinning = false;
  //         this.worklogData = data["data"];

  //         if (data["data"].length == data["count"]) {
  //           this.isWorklogLoadMoreButtonHide = true;
  //         }
  //       },
  //       (err) => {
  //         if (err["ok"] == false)
  //           this.notificationService.error("Server Not Found", "");
  //       }
  //     );

  //   // For Getting All Worklog
  //   this._apiService
  //     .getAllWorklogs(0, 0, "WORKED_DATETIME", "desc", filterStr)
  //     .subscribe(
  //       (data) => {
  //         this.allWorklogData = data["data"];

  //         this.calculateTrackedTime();
  //       },
  //       (err) => {}
  //     );
  // }
}
